import React from 'react';
import { Outlet } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';

import { RootStyle } from '../../theme/layouts';
import DashboardNavbar from './Navbar';
import DashboardSidebar from './Sidebar';
import { Box } from '@mui/material';

const DashboardLayout: React.FC = () => {
  return (
    <RootStyle>
      <CssBaseline />
      <Box
        sx={{
          width: 1,
          height: 1,
          display: 'grid',
          maxHeight: '100vh',
          gridTemplateRows: 'fit-content(64px) [nav_routerContent] 1fr',
          gridTemplateColumns: '[screenLeft] fit-content(315px) [routerContent] 1fr [screenRight]'
        }}
      >
        <Box sx={{ gridColumn: 'screenLeft / screenRight' }}>
          <DashboardNavbar />
        </Box>
        <Box sx={{ minHeight: 0, gridRow: 'nav_routerContent' }}>
          <DashboardSidebar />
        </Box>

        <Box
          component='main'
          sx={{
            minHeight: 0,
            gridRow: 'nav_routerContent',
            gridColumn: 'routerContent',
            py: 3,
            px: 6,
            overflowY: 'auto'
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </RootStyle>
  );
};
export default DashboardLayout;
